<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранный лендинг {{application.package_name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteApplication">Удалить</v-btn>
      </v-card-actions>
    </v-card>

    <OverlayLoader :show="isLoading"></OverlayLoader>

  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionApplicationModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    application: {
      get() {
        return this.$store.getters.CURRENT_APPLICATION;
      },
      set(value) {
        this.$store.commit('SET_CURRENT_APPLICATION', value);
      },
    },
    isOpen: {
      get(){
        return this.$store.getters.IS_APPLICATION_DELETION_MODAL_OPENED;
      },
      set(value){
        this.$store.commit('SET_APPLICATION_DELETION_MODAL_IS_OPENED', value);
      }
    },
    isLoading: {
      get(){
        return this.$store.getters.IS_APPLICATION_DELETION_MODAL_LOADING;
      },
      set(value){
        this.$store.commit('SET_APPLICATION_DELETION_MODAL_LOADING', value);
      }
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.application = {};
      this.isLoading = false;
      this.isOpen = false;
    },
    deleteApplication(){
      this.$store.dispatch('DELETE_APPLICATION', this.application.id)
        .then(() => {
          this.$toast.success('Лендинг удален');
          this.close();
        })
        .catch(() => {
          this.$toast.error('Ошибка при удалении');
        });
    }
  },
};
</script>
